import { useCallback, useContext } from 'react';
import { DOWNLOAD_BANNER_STATUS } from 'models/Download';
import shareableLinksDocuments from '../api/shareable-links-documents';
import downloadService from 'services/downloadService';
import ShareableLinkFileDownloadContext from '../providers/ShareableLinkFileDownload/ShareableLinkFileDownload.context';

export default function useStartDownloadingFile() {
  const { showDownloadBanner } = useContext(ShareableLinkFileDownloadContext);

  return useCallback(
    async (shareableLinkId: string, nodeId: string) => {
      try {
        showDownloadBanner(DOWNLOAD_BANNER_STATUS.PREPARING);
        await shareableLinksDocuments.startDownloadingFile(
          shareableLinkId,
          nodeId,
          downloadService.secureLinkDownloadUniqueId,
        );
      } catch {
        showDownloadBanner(DOWNLOAD_BANNER_STATUS.ERROR);
      }
    },
    [showDownloadBanner],
  );
}
